import React from "react";
import { connect } from "react-redux";
import { Button, Card, Form, Input } from 'antd';
import { changePasswordDuringLogin } from '../../appRedux/actions';

class ChangePassword1 extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      } else {
        this.props.changePasswordDuringLogin({
          currentPassword: values.currentPassword,
          password: values.password,
          confirmPassword: values.confirmPassword,
        })
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    };
    return (
      <Card className={`gx-card-metrics`}>
        <h2>Change Password</h2>
        <Form
          style={{ marginTop: '40px' }}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
          layout="vertical"
        >
          <Form.Item label="Current   Password">
            {getFieldDecorator("currentPassword", {
              rules: [{ required: true, message: 'Please input your current password!' }],
            })(<Input.Password />)}
          </Form.Item>
          <Form.Item label="Password">
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: 'Please input your password!' },
                { min: 6, max: 28, message: 'Password must be between 6 and 28 characters' },
              ],
            })(<Input.Password />)}
          </Form.Item>
          <Form.Item label="Confirm Password">
            {getFieldDecorator("confirmPassword", {
              rules: [{ required: true, message: 'Please input your Confirm password!' }],
            })(<Input.Password />)}
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              className="gx-mb-0"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changePasswordDuringLogin,
  };
}

const ChangePassword = Form.create({
  name: "global_state",
  // onFieldsChange(props, changedFields) {
  //   props.onChange(changedFields);
  // }
})(ChangePassword1);

export default connect(null, mapDispatchToProps())(ChangePassword);



